import styled from 'styled-components'
import { GLOBAL_COLORS } from 'theme'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

export const ColoredTriangle = styled.div<{ isPositive: boolean; size: string }>`
  width: 0;
  height: 0;
  border-left: ${({ size }) => +size.substring(0, size.length - 2) / 2.5}px solid
    ${GLOBAL_COLORS.transparent};
  border-right: ${({ size }) => +size.substring(0, size.length - 2) / 2.5}px solid
    ${GLOBAL_COLORS.transparent};
  border-top: ${({ size }) => +size.substring(0, size.length - 2) / 1.4}px solid
    ${({ isPositive }) => (isPositive ? GLOBAL_COLORS.canopyGreen : GLOBAL_COLORS.volcanoRed)};
  transform: rotate(${({ isPositive }) => (isPositive ? '180deg' : '0deg')});
`
